import { apiClient } from "@/programs/services/ApiClient.js";
import { programUserDataNavigationCountUrl } from "@/programs/urls.js";

export const getNavigationCounts = async (programId, admin) => {
  const url = programUserDataNavigationCountUrl.stringify({ programId });
  const { data } = await apiClient.get(url, { params: { admin } });
  return data;
};
